import { useEffect } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

export default function AnimatedNumber({ value, prefix = "$", suffix = "", decimals = 0, className = "" }) {
  const spring = useSpring(value, { stiffness: 90, damping: 22 });
  useEffect(() => {
    spring.set(value);
  }, [value, spring]);
  const text = useTransform(
    spring,
    (v) =>
      `${prefix}${Math.max(v, 0).toLocaleString("en-CA", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}${suffix}`
  );
  return <motion.span className={className}>{text}</motion.span>;
}
